import { AnimatePresence } from "framer-motion";
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AboutMe from "../pages/AboutMe";
import Contact from "../pages/Contact";
import Cookie from "../pages/Cookie";
import Demo from "../pages/Demo";
import DemoDetails from "../pages/DemoDetails";
import DemoRequest from "../pages/DemoRequest";
import Experiments from "../pages/Experiments";
import Home from "../pages/Home";
import PageNotFound from "../pages/NotFound";
import Privacy from "../pages/Privacy";
import Project from "../pages/Project";
import ProjectProd from "../pages/ProjectProd";
import ProjectDetails from "../pages/ProjectDetails";
import Skill from "../pages/Skill";
import ScrollToTop from "../ScrollToTop";

function AnimatedRoutes(props) {
  const location = useLocation();
  return (
    <AnimatePresence>
      <ScrollToTop>
        <Routes key={location.pathname} location={location}>
          <Route path="*" element={<PageNotFound />} />
          <Route exact path="/" element={<Home />} />
          <Route path="/skill" element={<Skill />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/demo/:slug" element={<DemoDetails />} />
          <Route path="/demo-request" element={<DemoRequest />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/project" element={<Project />} />
          <Route path="/project-prod" element={<ProjectProd />} />
          <Route path="/project/:slug" element={<ProjectDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="/experiments" element={<Experiments />} />
        </Routes>
      </ScrollToTop>
    </AnimatePresence>
  );
}
export default AnimatedRoutes;
